import { getId } from '@basehub/utils/id/index'
import { useStorage } from '~/hooks/use-storage'

export const useCommentDraftStorage = (editorKey: string | undefined) => {
  const [draft, setDraft, _, __, draftRef] = useStorage(
    'sessionStorage',
    (z) =>
      z.object({
        value: z.string(),
        // for idempotency
        id: z.string(),
      }),
    editorKey ?? '',
    { initialValue: { id: getId(), value: '' }, enabled: Boolean(editorKey) }
  )

  return { draft, setDraft, draftRef }
}
